import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "person-text" }
const _hoisted_2 = { class: "person-name" }
const _hoisted_3 = {
  key: 0,
  class: "person-email"
}
const _hoisted_4 = {
  key: 0,
  class: "person-actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_user_avatar = _resolveComponent("ontos-user-avatar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["person-line", {'person-line--dense': _ctx.dense}])
  }, [
    _createVNode(_component_ontos_user_avatar, {
      user: _ctx.user,
      label: _ctx.label,
      photo: _ctx.photo,
      size: _ctx.dense ? 24 : 36
    }, null, 8, ["user", "label", "photo", "size"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1),
      (_ctx.name && _ctx.email)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.email), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}